import Vue from 'vue'
import vueEsign from 'vue-esign'


Vue.use(vueEsign)